import AppBanner from './AppBanner';

// Shared page wrapper for all event pages
const PageLayout = ({ children }) => (
  <div className="page-container">
    <main className="main-content">
      <AppBanner />
      {children}
    </main>
  </div>
);

export default PageLayout;